import uuidv4 from "uuid/v4";

import alertifyConfirm from "./helpers/alertifyConfirm";
import arrayIdFinder from "./helpers/arrayIdFinder";
import axios from 'axios';
import employees from "./employees";

const Graph = {
  graph: {
    id: uuidv4(),
    entityName: "Organization Name",
    parentId: null
    // children: [
    //   {
    //     id: uuidv4(),
    //     label: "B",
    //     children: [{ id: uuidv4(), label: "C" }, { id: uuidv4(), label: "D" }]
    //   },
    //   {
    //     id: uuidv4(),
    //     label: "E",
    //     children: [
    //       {
    //         id: uuidv4(),
    //         label: "F",
    //         children: [{ id: uuidv4(), label: "G" }]
    //       }
    //     ]
    //   }
    // ]
  },
  baseURL: 'http://localhost:5001/ooops/api',
  token: 'Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6Ii05SnJmQXNTa1RmdThkMDNaUTh1UmciLCJ0eXAiOiJhdCtqd3QifQ.eyJuYmYiOjE2MDc4NTY1MTMsImV4cCI6MTYwNzg2MDExMywiaXNzIjoiaHR0cDovL2xvY2FsaG9zdDo1MDUwIiwiYXVkIjoib3JnY2hhcnQuYXBpIiwiY2xpZW50X2lkIjoib3JnY2hhcnQuYXBpLmlkIiwic2NvcGUiOlsib3JnY2hhcnQuYXBpIl19.TqxXIYh7MeBT6psJ4WYsHtE02BmohE6FRZ2QPRnHjtimzQ5kG-XTps50cyLXMSHvfsZG2T82oK0xhsFu5P1EvdBHvKDOww5-OwmODBPbXWJEi_nB0ien8ACweIjtiRkHRBGp01li_hXCjTAZgiXlfbGmasQ-uO8t_Wu9t8bRBbMurvwLygOVk4Pqb1YOxNwdMZGajQriHrhCjiZhJgxDqTjAyydbj9HC1iQ-2b8PhiExrJCDO4MfFqanbAu8pPXy3NPIXOm7zeuYUX-waTjdz_NwhUvRRzN0Rf06EwNk2KonykJGtPIgRju9zTpjYZmrHGQXXTv-ssCH3KhMFiiwVg',
  employeeList: {},
  employeesHierarchy: {},
  employeeDetails: function(e) {
    return arrayIdFinder(this.employeeList, e);
  },
  employeeMapping: {},
  employeeHierarchy:{},
  _createGraphIdMapping: function(graph) {
    let mapping = {};
    let children = graph.children || [];
    for (let child of children)
      mapping = { ...mapping, ...this._createGraphIdMapping(child) };
    return { ...mapping, [graph.id]: graph };
  },
  _createGraphEmployeeMapping: function() {
    let graphValues = Object.values(this.graphIdMapping);
    let empMapping = {};
      for(let entity of graphValues) {
        for(let emp of entity.employees) {
          empMapping[emp.id] = entity.id;
        }
      }
    return empMapping;
  },
  buildEmployees: function(){
    let flatEmployeeTree = this.flatEmployeesTree();
    let employeeTree = this.treeifyEmployees(flatEmployeeTree);
    this.employeesHierarchy = employeeTree[0];
    this.employeeList = this.arrayUnique(this.employeeList.concat(flatEmployeeTree));
    this.employeeMapping = this._createGraphEmployeeMapping();
    return this.employeeList;
  },
  mergeEmployees: function(employees) {
    this.employeeList = this.arrayUnique(this.employeeList.concat(employees));
    return this.employeeList;
  },
  flatEmployeesTree: function(){
    let graphValues = Object.values(this.graphIdMapping);
    let empFlatTree = [];
    for(let entity of graphValues) {
      let lineManager = entity.employees?.find(p => p.isLineManager);
      if(lineManager) {
        for(let emp of entity.employees) {
          let parentId = null;
        
          if(!emp.isLineManager && lineManager){
            parentId = lineManager.id;
          }
        
          else if(entity.parentId){
            let parentEntity = graphValues.find(p => p.id == entity.parentId);
            let parentEmp = parentEntity.employees.find(p => p.isLineManager);
            if(parentEmp){
              parentId = parentEmp.id;
            }
          } 

          let empFlatNode = {
            id: emp.id,
            entityId: entity.id,
            parentId: parentId,
            name: emp.name,
            position: emp.position,
            isLineManager: emp.id == lineManager?.id
          };
          empFlatTree.push(empFlatNode);
        }
      }
    }

    return empFlatTree;
  },
  treeifyEmployees: function treeify(list, idAttr, parentAttr, childrenAttr) {
    if (!idAttr) idAttr = 'id';
    if (!parentAttr) parentAttr = 'parentId';
    if (!childrenAttr) childrenAttr = 'children';

    var treeList = [];
    var lookup = {};
    list.forEach(function(obj) {
        lookup[obj[idAttr]] = obj;
        obj[childrenAttr] = [];
    });
    list.forEach(function(obj) {
        if (obj[parentAttr] != null) {
            if (lookup[obj[parentAttr]] !== undefined) {
                lookup[obj[parentAttr]][childrenAttr].push(obj);
            } else {
                 treeList.push(obj);
            }               
        } else {
            treeList.push(obj);
        }
    });
    return treeList;
},
arrayUnique: function arrayUnique(array) {
  var a = array.concat();
  for(var i=0; i<a.length; ++i) {
      for(var j=i+1; j<a.length; ++j) {
          if(a[i].id === a[j].id)
              a.splice(j--, 1);
      }
  }

  return a;
},
updateEmployeesTree: function(){
  let flatEmployeeTree = Graph.flatEmployeesTree();
  let employeeTree = this.treeifyEmployees(flatEmployeeTree);
  this.employeesHierarchy = employeeTree[0];
},
  graphIdMapping: {},
  registerUpdateCb: function(cb) {
    this._updateCb = cb;
  },
  add: function(entityName, parentId) {
    const node = { id: uuidv4(), entityName, parentId, children: null, employees: null };
    if (!this.graphIdMapping[parentId].children)
      this.graphIdMapping[parentId].children = [];
    this.graphIdMapping[parentId].children.push(node);
    this.graphIdMapping[node.id] = node;

    let entityModel = {
      id: 0,
      entityName: entityName,
      parentId: parentId,
      lineManager: null,
      companyId: 1,
      userId: '1'
    };

    axios.post(this.baseURL + '/orgchart/AddEntity', entityModel, {
          headers: {
            'Authorization': this.token
          }})
        .then(res => 
        {
          this._updateCb();
        });
  },
  edit: function(id, entityName, parentId) {
    const oldParentId = this.graphIdMapping[id].parentId;
    if (oldParentId !== parentId) {
      // parent changed
      if (parentId === id || this.isAncestor(parentId, id)) return;
      this.graphIdMapping[oldParentId].children = this.graphIdMapping[
        oldParentId
      ].children.filter(x => x.id !== id);
      this.graphIdMapping[id].parentId = parentId;
      if (!this.graphIdMapping[parentId].children)
        this.graphIdMapping[parentId].children = [];
      this.graphIdMapping[parentId].children.push(this.graphIdMapping[id]);
    }
    this.graphIdMapping[id].entityName = entityName;

    let updateEntityModel = {
      Id: id,
      EntityName:entityName,
      ParentId: parseInt(parentId),
      UserId: '1'
    };

    axios.post(this.baseURL + '/orgchart/UpdateEntity', updateEntityModel, {
          headers: {
            'Authorization': this.token
          }})
        .then(res => 
        {
          this._updateCb();
        });
  },
  delete: function(id) {
    const oldParentId = this.graphIdMapping[id].parentId;
    if (!oldParentId) return; // dont delete root
    this.graphIdMapping[oldParentId].children = this.graphIdMapping[
      oldParentId
    ].children.filter(x => x.id !== id);
    delete this.graphIdMapping[id];

    let deleteEntityModel = {
      id: id,
      userId: '1'
    };

    axios.post(this.baseURL + '/orgchart/RemoveEntity', deleteEntityModel, {
          headers: {
            'Authorization': this.token
          }})
        .then(res => 
        {
          this._updateCb();
        });
  },
  addEmployees: async function(id, employees) {
    let currentEntityEmployeesIds = [];
    if (!this.graphIdMapping[id].employees)
      this.graphIdMapping[id].employees = [];
    else
      currentEntityEmployeesIds = this.graphIdMapping[id].employees.map(e => e.id);
    let toadd = employees.filter(
      e => currentEntityEmployeesIds.indexOf(parseInt(e)) === -1
    );

    let toskip = [];
    for (let e of toadd) {
      if (
        this.employeeMapping[parseInt(e)] &&
        !(await alertifyConfirm(
          `The employee ${
            this.employeeDetails(parseInt(e)).name
          } is already present in one or more entities. Are you sure you want to add him/her?`,
          { ok: "Add anyways", cancel: "Skip" }
        ))
      )
        toskip.push(e);
    }
    toadd = await toadd.filter(e => toskip.indexOf(e) === -1);
    toadd = toadd.map(x => {
      return parseInt(x)
    });
    toadd = [...new Set(toadd)];
    let objectsToAdd = this.employeeList.filter(x => toadd.includes(x.id));
    
    this.graphIdMapping[id].employees = [
      ...this.graphIdMapping[id].employees,
      ...objectsToAdd
    ];
    toadd.forEach(e => (this.employeeMapping[e] = id));

    if(toadd.length == 0)
      return;

    if (!this.graphIdMapping[id].lineManager)
      this.graphIdMapping[id].lineManager = this.graphIdMapping[
        id
      ].employees[0].id;

      let addEmployeesModel = {
        EmployeeIds:toadd,
        EntityId: id,
        userId: '1'
      };

      axios.post(this.baseURL + '/orgchart/AddEmployeesToEntity', addEmployeesModel, {
        headers: {
          'Authorization': this.token
        }})
      .then(res => 
      {
        this.updateEmployeesTree();
        this._updateCb();
      });
  },
  removeEmployee: function(id, toremove) {
    this.graphIdMapping[id].employees.splice(this.graphIdMapping[id].employees.findIndex(e => e.id === toremove.id), 1);
    this.employeeMapping[toremove.id] = undefined;
    // this.graphIdMapping[id].employees = this.graphIdMapping[
    //   id
    // ].employees.filter(e => e !== toremove);
    // this.employeeMapping[toremove] = undefined;
    // if (this.graphIdMapping[id].lineManager === toremove)
    //   this.graphIdMapping[id].lineManager = undefined;

    let removeEmployeesModel = {
      EmployeeId:toremove.id,
      EntityId: id,
      userId: '1'
    };

    axios.post(this.baseURL + '/orgchart/RemoveEmployeeFromEntity', removeEmployeesModel, {
        headers: {
          'Authorization': this.token
        }})
      .then(res => 
      {
        this.updateEmployeesTree();
        this._updateCb();
      });
  },
  setLineManager: function(id, employee) {
    this.graphIdMapping[id].lineManager = null;
    this.graphIdMapping[id].employees.forEach(x => {
      if(x.isLineManager){
        x.isLineManager = false;
        this.employeeList.find(e => e.id == x.id).isLineManager = false;
      }
    });
    if(employee) {
      this.graphIdMapping[id].employees.find(x => x.id == employee.id).isLineManager = true;
      this.graphIdMapping[id].lineManager = employee.id;
    }

    let updateLineManagerModel = {
      EntityId:id,
      EmployeeId: employee ? employee.id : null,
      UserId: '1'
    };
    
    axios.post(this.baseURL + '/orgchart/UpdateLineManager', updateLineManagerModel, {
        headers: {
          'Authorization': this.token
        }})
      .then(res => 
      {
        this.updateEmployeesTree();
        this._updateCb();
      });

    this.updateEmployeesTree();
    this._updateCb();
  },
  isAncestor: function(id, possibleAncestorId) {
    // true if possibleAncestorId is an ancestor of id
    let node = this.graphIdMapping[id];
    while (node.parentId && node.parentId !== possibleAncestorId)
      node = this.graphIdMapping[node.parentId];
    if (node.parentId) return true;
    else return false;
  }
};

Graph.isAncestor = Graph.isAncestor.bind(Graph);
Graph.graphIdMapping = Graph._createGraphIdMapping(Graph.graph);

export default Graph;
